import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Select } from '@guildeducationinc/recess';
import classNames from 'classnames';
import { TrackableButton, useLocale } from 'pe-core-frontend';
import styles from './FieldFilter.module.scss';
export const FieldFilter = ({ filter, onFilterChange, className }) => {
    const { t } = useLocale();
    const handleReset = () => {
        onFilterChange({
            searchText: filter.searchText, // keep the search text
            isActive: true,
        });
    };
    return (_jsxs("div", { className: classNames(styles.fieldFilter, className), children: [_jsx("div", { children: _jsx(Select, { isClearable: false, className: 'w-60', label: t('Status'), value: filter.isActive === undefined ? 'all' : filter.isActive ? 'active' : 'inactive', onChange: e => onFilterChange({
                        ...filter,
                        isActive: e.target.value === 'all' ? undefined : e.target.value === 'active',
                    }), options: [
                        { value: 'active', label: t('Active') },
                        { value: 'inactive', label: t('Inactive') },
                        { value: 'all', label: t('All') },
                    ] }) }), _jsx(TrackableButton, { btnType: 'mui', enText: 'Reset', tag: 'field_filter', onClick: handleReset, variant: 'outlined', color: 'primary', children: t('Reset') })] }));
};
